import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import {
  GovernmentAllocationEntryProductValidationSchema,
} from "@/features/privateCompanies/pages/CompanyGovernmentAllocations/schemas/update.schema";

type EntryProductQuantity = {
  id?: string | null;
  product: { id: string };
  total_quantity: string;
  total_value?: string | null;
};

export const transformNewProduct = (formProduct: GovernmentAllocationEntryProductValidationSchema) => {
  return {
    product_id: formProduct.product.id,
    total_value: formProduct.total_value ? unFormatCurrency(formProduct.total_value) : null,
  };
};

export const transformUpdatedProduct = (formProduct: GovernmentAllocationEntryProductValidationSchema) => {
  const { product_id, ...transformedProduct } = transformNewProduct(formProduct);

  return {
    id: formProduct.id,
    ...transformedProduct,
  };
};

export const transformNewProductQuantity = (formProduct: EntryProductQuantity, governmentAllocationCurrencyRestricted: boolean | undefined) => {
  return {
    product_id: formProduct.product.id,
    total_quantity: formProduct.total_quantity ? Number(unFormatUnknownUnit(formProduct.total_quantity)) || 0 : 0,
    total_value:
      governmentAllocationCurrencyRestricted
        ? formProduct.total_value ? Number(unFormatCurrency(formProduct.total_value)) || 0 : 0
        : undefined,
  };
};

export const transformUpdatedProductQuantity = (formProduct: EntryProductQuantity, governmentAllocationCurrencyRestricted: boolean | undefined) => {
  const { product_id, ...transformedProduct } = transformNewProductQuantity(formProduct, governmentAllocationCurrencyRestricted);

  return {
    id: formProduct.id,
    ...transformedProduct,
  };
};
